const ACCESS_TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const TOKEN_TYPE_KEY = 'token_type';
const TEMP_TOKEN_KEY = 'temp_token';
const PERSIST_KEY_PREFIX = 'persist:';

export function setAuthTokens(payload = {}) {
  const { access_token, refresh_token, token_type } = payload;

  if (access_token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
  }

  if (refresh_token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
  }

  if (token_type) {
    localStorage.setItem(TOKEN_TYPE_KEY, token_type);
  }
}

export function setTempToken(token) {
  if (typeof token === 'string') {
    localStorage.setItem(TEMP_TOKEN_KEY, token);
  }
}

export function clearTempToken() {
  localStorage.removeItem(TEMP_TOKEN_KEY);
}

export function getTempToken() {
  return localStorage.getItem(TEMP_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getTokenType() {
  return localStorage.getItem(TOKEN_TYPE_KEY) || 'Bearer';
}

export function clearAuthTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TOKEN_TYPE_KEY);
  clearTempToken();
}

function clearPersistedState() {
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith(PERSIST_KEY_PREFIX)) {
      localStorage.removeItem(key);
    }
  }
}

export function clearSession() {
  clearAuthTokens();
  clearPersistedState();
}
